// package imports
import React, { useEffect } from 'react';
import { Portal } from 'react-portal';

// CSS imports
import './Alert.css';

// Type imports
import { AlertSize } from '../../types/alert/AlertSize';
import { AlertColor } from '../../types/alert/AlertColor';

type Props = {
  children?: React.ReactNode;
  showAlert: boolean;
  size?: AlertSize;
  time?: number;
  color?: AlertColor;
  setShowAlert: (x: boolean) => void;
};

const Alert: React.FC<Props> = ({
  children,
  showAlert,
  size,
  time,
  color,
  setShowAlert,
}: Props) => {
  useEffect(() => {
    if (showAlert && time !== undefined) {
      setTimeout(() => {
        setShowAlert(false);
      }, time);
    }
  }, [showAlert, time, setShowAlert]);

  return showAlert ? (
    <Portal>
      <div
        className={`Alert ${
          size === AlertSize.SMALL
            ? 'small-alert'
            : size === AlertSize.LARGE
            ? 'large-alert'
            : ''
        } ${color === AlertColor.GREEN ? 'alert-green' : ''}`}
      >
        {children}
      </div>
    </Portal>
  ) : null;
};

export default Alert;
